'use strict';

import React from 'react';
import Router from 'react-router';
import Flux from 'utils/flux';
import api from 'utils/api';
import routes from 'routes';
import store from 'store';

require('core-js/es6/array');

// load tcomb-form without templates and i18n
var t = require('tcomb-form/lib');
t.form.Form.i18n = require('tcomb-form/lib/i18n/en');
t.form.Form.templates = require('components/forms/template');

window.React = React; // For React Developer Tools

if (!global.Intl) {
    global.Intl = require('intl');
}

api.getLocale('en').then( languageData => {
    Flux.getActions('translations').addLocaleData({
        "locale": "en",
        "pluralRuleFunction": function (n,ord) {
            var s=String(n).split("."),
                v0=!s[1],
                t0=Number(s[0])==n,
                n10=t0&&s[0].slice(-1),
                n100=t0&&s[0].slice(-2);

            if ( ord )
                return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";

            return n == 1 && v0 ? "one" : "other"
        }
    });

    Flux.getActions('translations').addMessages({
        locales: ['en'],
        messages: languageData
    });

    // Check if we are authenticated
    if( !Flux.getStore('app').isAuthenticated() ) {
        store.set( '_CSRF', languageData._CSRF );
    }

    // Render the app at correct URL
    Router.run( routes, ( Handler, state ) => {
        // We need to force Close all Modals on transtion
        Flux.getActions('modals').closeModals();
        Flux.getStore('app').closeOffcanvas();

        // Render the app
        React.render(
            <Handler flux={Flux} {...state} />,
            document.getElementById('app')
        );
    });
});



// WEBPACK FOOTER //
// ./app/index.jsx